// assets/a24-navigation-ui.js
/* Desktop navigation dropdowns and mobile subnavigation accordions. */
(function () {
  'use strict';

  function initMobileAccordions() {
    var toggles = document.querySelectorAll('#mobileDrawer .mobile-drawer__accordion-toggle[data-target]');

    toggles.forEach(function (toggle) {
      if (toggle.dataset.a24NavigationBound === '1') return;
      toggle.dataset.a24NavigationBound = '1';

      toggle.addEventListener('click', function () {
        var targetId = toggle.getAttribute('data-target');
        if (!targetId) return;

        var subMenu = document.getElementById(targetId);
        if (!subMenu) return;

        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        subMenu.classList.toggle('open', !isOpen);
      });
    });
  }

  function initDesktopDropdowns() {
    var mainNav = document.getElementById('mainNav') || document.getElementById('cmsMainNav');
    if (!mainNav || mainNav.dataset.a24NavigationBound === '1') return;

    var dropdownItems = mainNav.querySelectorAll('.main-nav__item--dropdown');
    if (!dropdownItems.length) return;

    mainNav.dataset.a24NavigationBound = '1';

    var isTouchCapable = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);

    function closeAllDropdowns() {
      mainNav.querySelectorAll('.main-nav__item--dropdown.main-nav__item--open').forEach(function (item) {
        item.classList.remove('main-nav__item--open');
      });
    }

    function isDesktopMenuVisible() {
      return window.matchMedia('(min-width: 769px)').matches
        && window.getComputedStyle(mainNav).display !== 'none';
    }

    dropdownItems.forEach(function (item) {
      var link = item.querySelector(':scope > .main-nav__link');
      if (!link) return;

      link.addEventListener('click', function (event) {
        /* Keep Shopify Preview Inspector clicks completely native. */
        if (window.A24Theme?.shouldProtectEditorClicks?.()) return;
        if (!isTouchCapable || !isDesktopMenuVisible()) return;

        var isOpen = item.classList.contains('main-nav__item--open');
        if (isOpen) return;

        event.preventDefault();
        event.stopPropagation();

        closeAllDropdowns();
        item.classList.add('main-nav__item--open');
      });
    });

    document.addEventListener('click', function (event) {
      if (!mainNav.contains(event.target)) closeAllDropdowns();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAllDropdowns();
    });
  }

  function init() {
    initDesktopDropdowns();
    initMobileAccordions();
  }

  if (window.A24Theme && typeof window.A24Theme.onReady === 'function') {
    window.A24Theme.onReady(init);
  } else {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  }
}());
